var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('loader'):_c('div',{attrs:{"data-aos":"fade","data-aos-anchor-placement":"top-buttom","data-aos-duration":"500"}},[_c('h-header',{on:{"changeLangEmit":_vm.changLang}}),_c('router-view'),_c('f-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }